import React from 'react';

const TITRES_PAR_ANNEXE = {
  B1: 'PALANS, PONTS ROULANTS, PORTIQUES',
  B2: 'GRUES À TOUR',
  B3: 'GRUES MOBILES',
  B4: 'PONTS ÉLÉVATEURS DE VÉHICULES',
  B5: 'CHARIOT À PORTÉE VARIABLE',
  B6: 'PLATES-FORMES ÉLÉVATRICES MOBILES DE PERSONNEL (PEMP)',
  B7: 'HAYONS ÉLÉVATEURS',
  B8: 'MONTE-MATÉRIAUX ET MONTE-MEUBLES',
  B9: 'AUTRES APPAREILS DE LEVAGE',
  B10: 'APPAREILS DE LEVAGE MUS À BRAS',
  B11: 'ENGINS DE CHANTIER À CONDUCTEUR PORTÉ',
  C1: 'ACCESSOIRES DE LEVAGE',
  D1: 'ÉCHAFAUDAGES',
};

const styles = {
  page: {
    width: '210mm',
    height: '297mm',
    background: 'white',
    position: 'relative',
    fontFamily: 'Arial, sans-serif',
    fontSize: '12px',
  },
  headerRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '24px 24px 0',
  },
  logoWrap: {
    width: '120px',
  },
  logo: {
    height: '64px',
    objectFit: 'contain',
  },
  banner: {
    background: 'linear-gradient(to right, #9ca3af, #6b7280, #22c55e)',
    color: 'white',
    padding: '12px 24px',
    borderRadius: '12px 0 0 12px',
  },
  bannerTitle: {
    fontSize: '18px',
    fontWeight: 700,
  },
  bannerText: {
    fontSize: '12px',
    marginTop: '4px',
  },
  body: {
    padding: '0 32px',
    marginTop: '24px',
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: '24px',
  },
  colHalf: {
    width: '48%',
  },
  titleBox: {
    border: '2px solid #000',
    textAlign: 'center',
    padding: '8px',
    marginBottom: '16px',
  },
  photoBox: {
    width: '48%',
    background: '#f1f5f9',
    border: '2px solid #9ca3af',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  photo: {
    width: '100%',
    height: '190px',
    objectFit: 'cover',
  },
  table: {
    width: '48%',
    borderCollapse: 'collapse',
    fontSize: '11px',
  },
  th: {
    border: '1px solid #000',
    padding: '4px 6px',
    fontWeight: 700,
    background: '#f3f4f6',
  },
  td: {
    border: '1px solid #000',
    padding: '4px 6px',
  },
  avisBox: {
    border: '2px solid #000',
    marginBottom: '16px',
  },
  avisHeader: {
    background: '#f3f4f6',
    padding: '6px 10px',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontWeight: 700,
    color: '#b91c1c',
  },
  avisContent: {
    padding: '10px',
  },
  footer: {
    position: 'absolute',
    bottom: '16px',
    left: 0,
    right: 0,
    padding: '0 32px',
    fontSize: '10px',
    color: '#6b7280',
  },
  footerLine: {
    borderTop: '1px solid #cbd5e1',
    paddingTop: '6px',
    textAlign: 'center',
  },
  footerRight: {
    textAlign: 'right',
    marginTop: '4px',
  },
};

export default function Page1CouvertureLevage({ rapport, client, parametres, inspecteur }) {
  const p = parametres || {};
  const c = client || {};
  const r = rapport || {};
  const i = inspecteur || {};
  const etape1 = r.etape_1_infos_generales_levage || {};
  const etape2 = r.etape_2_caracteristiques_techniques_levage || {};
  const etape3 = r.etape_3_photos_machine_levage || {};
  const etape5 = r.etape_5_documentation_essais_levage || {};

  let codeAnnexe = etape1.famille_machine_code;
  if (!codeAnnexe && etape1.famille_machine_nom) {
    const match = etape1.famille_machine_nom.match(/^(B\d+|C\d+|D\d+)/);
    if (match) codeAnnexe = match[1];
  }
  if (!codeAnnexe) codeAnnexe = 'B5';

  const designationNom = etape2.designation_nom || etape1.designation_nom || '';
  const titreMachine = designationNom ? designationNom.toUpperCase() : (TITRES_PAR_ANNEXE[codeAnnexe] || 'APPAREIL DE LEVAGE');

  const photos = etape3.photos || [];
  const premierePhoto = photos.length > 0 ? photos[0] : null;

  const nomInspecteur = r.verificateur || (i.prenom && i.nom ? `${i.prenom} ${i.nom}` : '');
  const signatureUrl = i.signature_url || p.signature_email_url;

  const nomClient = c.entreprise || c.nom || `${c.prenom || ''} ${c.nom || ''}`.trim();

  return (
    <div style={styles.page} className="pdf-page">
      <div style={styles.headerRow}>
        <div style={styles.logoWrap}>
          {p.company_logo_url && (
            <img src={p.company_logo_url} alt="Logo" style={styles.logo} />
          )}
        </div>
        <div style={styles.banner}>
          <div style={styles.bannerTitle}>Vérification générale périodique</div>
          <div style={styles.bannerText}><strong>Client : {nomClient}</strong></div>
          <div style={styles.bannerText}>{c.adresse}</div>
          <div style={styles.bannerText}>{c.code_postal} {c.ville}</div>
          <div style={{ ...styles.bannerText, marginTop: '6px' }}>
            <strong>Rapport de vérification : {r.numero_rapport}</strong>
          </div>
        </div>
      </div>

      <div style={styles.body}>
        <div style={styles.row}>
          <div style={styles.colHalf}>
            <div><em>Réglementation appliquée :</em> Arrêté du 1er mars 2004</div>
            <div style={{ marginTop: '8px' }}><em>Lieu du contrôle :</em></div>
            <div>{r.etablissement}</div>
            <div>{r.site_adresse}</div>
          </div>
          <div style={{ ...styles.colHalf, textAlign: 'right' }}>
            <div><em>Inspecteur :</em> <strong>{nomInspecteur}</strong></div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '8px', marginTop: '8px' }}>
              <span style={{ fontStyle: 'italic' }}>Visa :</span>
              <div style={{ height: '64px', display: 'flex', alignItems: 'center' }}>
                {signatureUrl && <img src={signatureUrl} alt="Signature" style={{ height: '48px' }} />}
              </div>
            </div>
            <div style={{ marginTop: '8px' }}>
              <em>Date :</em> {r.date_verification ? new Date(r.date_verification).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' }) : ''}
            </div>
          </div>
        </div>

        <div style={styles.titleBox}>
          <div style={{ fontSize: '16px', fontWeight: 700 }}>{titreMachine}</div>
        </div>

        <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
          <div style={styles.photoBox}>
            {premierePhoto ? (
              <img src={premierePhoto} alt="Machine" style={styles.photo} />
            ) : (
              <div style={{ color: '#64748b' }}>Aucune photo disponible</div>
            )}
          </div>
          <table style={styles.table}>
            <tbody>
              <tr><td style={styles.th}>MARQUE</td><td style={styles.td}>{etape2.marque || ''}</td></tr>
              <tr><td style={styles.th}>TYPE</td><td style={styles.td}>{etape2.type || ''}</td></tr>
              <tr><td style={styles.th}>ANNÉE</td><td style={styles.td}>{etape2.annee || ''}</td></tr>
              <tr><td style={styles.th}>N° de SÉRIE</td><td style={styles.td}>{etape2.numero_serie || ''}</td></tr>
              <tr><td style={styles.th}>CONFORMITÉ</td><td style={styles.td}>{etape2.conformite || 'CE'}</td></tr>
              {etape2.numero_parc && (
                <tr><td style={styles.th}>N° de PARC</td><td style={styles.td}>{etape2.numero_parc}</td></tr>
              )}
              {etape2.compteur && (
                <tr><td style={styles.th}>COMPTEUR</td><td style={styles.td}>{etape2.compteur} {etape2.compteur_unite || 'heures'}</td></tr>
              )}
              {etape2.utilisateur && (
                <tr><td style={styles.th}>UTILISATEUR</td><td style={styles.td}>{etape2.utilisateur}</td></tr>
              )}
            </tbody>
          </table>
        </div>

        <div style={styles.avisBox}>
          <div style={styles.avisHeader}>AVIS GÉNÉRAL</div>
          <div style={styles.avisContent}>
            {etape5.appareil_non_controle ? (
              <div>
                <div style={{ fontWeight: 700, color: '#7f1d1d', textAlign: 'center' }}>⚠️ APPAREIL NON CONTRÔLÉ</div>
                <div style={{ marginTop: '6px', color: '#991b1b' }}>
                  <strong>Motif : </strong>
                  {etape5.motif_non_controle === 'immobilise' && 'Appareil immobilisé'}
                  {etape5.motif_non_controle === 'panne' && 'Appareil en panne'}
                  {etape5.motif_non_controle === 'conditions_securite' && "Les conditions d'essai en sécurité ne sont pas réunies"}
                  {etape5.motif_non_controle === 'non_presente' && 'Machine non présentée'}
                </div>
                {etape5.motif_non_controle_autre && (
                  <div style={{ color: '#b91c1c', fontStyle: 'italic', marginTop: '6px' }}>
                    {etape5.motif_non_controle_autre}
                  </div>
                )}
              </div>
            ) : (
              <div>
                {r.etape_11_observations?.observations?.length > 0
                  ? "La vérification a fait apparaître des défectuosités ou anomalies auxquelles il y a lieu de remédier."
                  : "La vérification n'a pas fait apparaître de défectuosités ou anomalies."}
              </div>
            )}
          </div>
        </div>
      </div>

      <div style={styles.footer}>
        <div style={styles.footerLine}>
          <div>{p.company_name} - {p.legal_form} au capital de {p.capital}</div>
          <div>N° Siret : {p.siret_number} - R.C.S. {p.rcs_number} - Code APE : {p.ape_code}</div>
          <div style={styles.footerRight}>Page 1 / 6</div>
        </div>
      </div>
    </div>
  );
}
